import dayjs from "dayjs";
import {
  ColumnTitle,
  TableBody,
  TableColumn,
  TableContainer,
  TableHead,
  TableHeader,
  TableRowOrdemService,
  TableTitle,
} from "../../../../../../../CSSGlobal";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { CircularProgress } from "@mui/material";

export function TabelaCorrelacionadas({
  tarefasCorrelacionadas,
  setLoadings,
  consultarObrigacao,
  setIsTarefaCorrelacionada,
  armazCorrelacionais,
  taskId

}) {
  const [titleTable, setTitleTable] = useState([
    {
        "id": 1,
        "titles": [
            {
                "title": "Vencimento"
            },
            {
                "title": "Obrigação"
            },
            {
                "title": "Descrição"
            },
            {
                "title": "Situação"
            },
            {
                "title": "Operações"
            }
        ]
    }
]
);
  const [isLoadingCicle, setIsLoadingCicle] = useState(false);
  const [isModalConfirm, setIsModalConfirm] = useState(false);
  const [selectedNFEId, setSelectedNFEId] = useState(null);

  const removerCorrelacionais = async () => {
    setIsLoadingCicle(true);
    const IdCorrelacional = armazCorrelacionais?.id;

    const url = "/portal/rest/contador/obrigacao/remover";
    const data = {
      id: IdCorrelacional,
    };

    setLoadings(true);
    try {
      const response = await axios.post(url, data, { withCredentials: true });
      if (response.status === 204) {
        setIsLoadingCicle(false);
        setIsModalConfirm(false);
        toast.success("Excluído com sucesso!");
        await consultarObrigacao(taskId);

        // Verificar se ainda há correlacionais após a exclusão
        if (!tarefasCorrelacionadas || tarefasCorrelacionadas.length === 0) {
          setIsTarefaCorrelacionada(false); // Desaparece a tabela se vazio
        }
      } else {
        setIsLoadingCicle(false);
        toast.error("Erro ao excluir NF-e");
      }
    } catch (error) {
      console.error("Erro ao remover obrigação:", error);
      setIsLoadingCicle(false);
    } finally {
      setLoadings(false);
    }
  };

  const openModalConfirm = (id) => {
    setIsModalConfirm(true);
  };

  return (
    <>
      <TableHeader>
        <TableHead>
          {titleTable[0].titles.map((item, index) => {
            return (
              <ColumnTitle key={index} id={index}>
                <TableTitle>
                  <span>{item.title}</span>
                </TableTitle>
              </ColumnTitle>
            );
          })}
        </TableHead>
      </TableHeader>
      <TableContainer>
        <TableBody>
          {tarefasCorrelacionadas.map((tarefa, index) => (
            <TableRowOrdemService key={index}>
              <TableColumn>
                <span>
                  {dayjs(tarefa.dataVencimentoObg).format("DD-MM-YYYY")}
                </span>
              </TableColumn>
              <TableColumn>
                <span>
                  {tarefa.obrgId} - {tarefa.obrigacaoSigla}
                </span>
              </TableColumn>
              <TableColumn>
                <span>{tarefa.descricao}</span>
              </TableColumn>
              <TableColumn>
                <span>{tarefa.situacaoNome}</span>
              </TableColumn>
              <TableColumn>
                <Button
                  type="primary"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation(); // Parar a propagação do clique
                    openModalConfirm(tarefa.idObg);
                  }}
                  //loading={loading}
                  style={{ zIndex: "2" }}
                >
                  Excluir
                </Button>
              </TableColumn>
            </TableRowOrdemService>
          ))}
        </TableBody>
      </TableContainer>

      <Modal
        title="Excluir Tarefa correlacionada"
        open={isModalConfirm}
        onOk={() => removerCorrelacionais(selectedNFEId)}
        onCancel={() => setIsModalConfirm(false)}
      >
        <p>
          Tem certeza que deseja excluir a obrigação <strong>{taskId}</strong> ?
        </p>

        {isLoadingCicle && (
          <div
            style={{
              margin: 20,
              width: "100%",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress className="cicleProgress" disableShrink />
          </div>
        )}
      </Modal>
    </>
  );
}

export default TabelaCorrelacionadas;
